/**
 * Draws the detected card contour on a canvas overlay.
 */
export function drawCardContour(ctx, corners, color = '#00ff88', lineWidth = 3) {
  ctx.strokeStyle = color;
  ctx.lineWidth = lineWidth;
  ctx.lineJoin = 'round';

  ctx.beginPath();
  ctx.moveTo(corners[0].x, corners[0].y);
  ctx.lineTo(corners[1].x, corners[1].y);
  ctx.lineTo(corners[2].x, corners[2].y);
  ctx.lineTo(corners[3].x, corners[3].y);
  ctx.closePath();
  ctx.stroke();

  // Draw corner dots
  const dotRadius = 6;
  ctx.fillStyle = color;
  for (const corner of corners) {
    ctx.beginPath();
    ctx.arc(corner.x, corner.y, dotRadius, 0, Math.PI * 2);
    ctx.fill();
  }
}

/**
 * Draws a card placeholder with a solid green border.
 */
export function drawGuideRect(ctx, width, height, label) {
  const cardWidth = width * 0.8;
  const cardHeight = cardWidth * (2.125 / 3.375); // standard card aspect ratio
  const x = (width - cardWidth) / 2;
  const y = (height - cardHeight) / 2;
  const radius = 12;

  // Draw label above the rectangle
  if (label) {
    const fontSize = Math.max(16, Math.round(width / 25));
    ctx.font = `bold ${fontSize}px sans-serif`;
    const textMetrics = ctx.measureText(label);
    const textW = textMetrics.width + 24;
    const textH = fontSize + 16;
    const textX = (width - textW) / 2;
    const textY = y - textH - 12;

    // Background pill
    ctx.fillStyle = 'rgba(0, 0, 0, 0.6)';
    ctx.beginPath();
    ctx.roundRect(textX, textY, textW, textH, textH / 2);
    ctx.fill();

    // Text
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(label, width / 2, textY + textH / 2);
    ctx.textAlign = 'start';
    ctx.textBaseline = 'alphabetic';
  }

  // Draw rounded rectangle with green border
  ctx.strokeStyle = '#00cc66';
  ctx.lineWidth = 10;
  ctx.lineJoin = 'round';
  ctx.setLineDash([]);

  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + cardWidth - radius, y);
  ctx.arcTo(x + cardWidth, y, x + cardWidth, y + radius, radius);
  ctx.lineTo(x + cardWidth, y + cardHeight - radius);
  ctx.arcTo(x + cardWidth, y + cardHeight, x + cardWidth - radius, y + cardHeight, radius);
  ctx.lineTo(x + radius, y + cardHeight);
  ctx.arcTo(x, y + cardHeight, x, y + cardHeight - radius, radius);
  ctx.lineTo(x, y + radius);
  ctx.arcTo(x, y, x + radius, y, radius);
  ctx.closePath();
  ctx.stroke();
}
